import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

/**
 * Clave en sessionStorage que marca una sesión abierta vía el link con
 * ?token= que llega al cliente por correo (ver ClientesComponent).
 */
export const CLIENTE_SCOPE_KEY = 'cliente-scope-token';

/**
 * Una sesión marcada como "cliente" (abierta desde el link con token que
 * llega por correo, sin login real de staff) solo puede navegar dentro de
 * /clientes. Cualquier otra ruta del SPA la redirige de vuelta.
 */
export const ClienteScopeGuard: CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    const isClienteScope = sessionStorage.getItem(CLIENTE_SCOPE_KEY) === '1';
    if (isClienteScope && !state.url.startsWith('/clientes')) {
        return router.parseUrl('/clientes');
    }

    return true;
};
